import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {simpleListHeader_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/simpleListHeader_template";
import {filterMultipleAutoComplete_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterMultipleAutoComplete_template";

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {presetFilter_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/presetFilter_template";
import {exportDataCsv} from "../../../vendor/valnet/valnet_jslib/vnHelpers/exportDataCsv";


declare var ko: any;
declare var page: any;


export class tagPerformanceArticleReport_template extends vnTemplate {

    public filterInitiatives: multipleSelector_template;
    public filterIntents: multipleSelector_template;
    public filterContentTypes: multipleSelector_template;
    public filterGoogleSources: multipleSelector_template;
    public filterDates: filterDate_template;
    public filterPublishDates: filterDate_template;
    public primaryCategoriesFilter : filterMultipleAutoComplete_template;

    protected pagination: pagination_template;

    protected exportDataCsv: exportDataCsv;

    protected headers: simpleListHeader_template;

    public presetFilter: presetFilter_template;

    public validationsList: validationsList_template;

    readonly viewModes = [

        {"id": "article", "name": "Article"},
    ];

    readonly dataSources= [

        {"id": "ga", "name": "Google Analytics"},
        {"id": "sc", "name": "Search Console"},
    ];


    readonly googleSources= [

        {"id": "search", "name": "Search"},
        {"id": "discover", "name": "Discover"},
        {"id": "news", "name": "News"},
    ];

    readonly gaDataSourceHeaders = [

        {headerName: "Article", fieldName: "title", subHeaders: []},
        {headerName: "Latest PubDate", fieldName: "datePublish", subHeaders: []},
        {headerName: "Mapping", fieldName: "initiativeName", subHeaders: []},
        {headerName: "Intent", fieldName: "intentName", subHeaders: []},
        {headerName: "Content Type", fieldName: "contentTypeName", subHeaders: []},
        {headerName: "Sessions", fieldName: "sessions", subHeaders: []},
        {headerName: "Trend", fieldName: "", subHeaders: []},
    ];

    readonly scDataSourceHeaders = [

        {headerName: "Article", fieldName: "title", subHeaders: []},
        {headerName: "Latest PubDate", fieldName: "datePublish", subHeaders: []},
        {headerName: "Mapping", fieldName: "initiativeName", subHeaders: []},
        {headerName: "Intent", fieldName: "intentName", subHeaders: []},
        {headerName: "Content Type", fieldName: "contentTypeName", subHeaders: []},
        {headerName: "Clicks", fieldName: "clicks", subHeaders: []},
        {headerName: "Impressions", fieldName: "impressions", subHeaders: []},
        {headerName: "CTR", fieldName: "ctr", subHeaders: []},
        {headerName: "Trend", fieldName: "", subHeaders: []},
        {headerName: "Distribution", fieldName: "", subHeaders: []},
    ];

    protected getTemplateHtml(): string {

        return `
            <div class="sub-header">
                
                <div class="w-justify">
                    <div class="w-left">
                    
                        <div class="dropdown select-single">
                            <label class="form-label" for="">View Mode</label>
                            <button class="dropdown-toggle" type="button" data-bind="text: viewModeSelectedText"></button>
                            
                            <div class="dropdown-list"> 
                                <div class="w-form">   
                                    <div class="form-group" data-bind="foreach: viewModes">
                                        <input type="radio" data-bind="checked : $parent.viewModeSelected, value: id,  attr: { 'id': 'view_' + id, 'name' : 'view_' + id }, event:{ change: $parent.onViewModeChange}">
                                        <label class="form-label" data-bind="attr: {for : 'view_' + id }, text: name"></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div>
                            ${this.filterInitiatives.getHtmlBuild()}
                        </div>
                        
                        <div>
                            ${this.filterIntents.getHtmlBuild()}
                        </div>
                        
                        <div>
                            ${this.filterContentTypes.getHtmlBuild()}
                        </div>

                        <div>
                            ${this.primaryCategoriesFilter.getHtmlBuild()}
                        </div>
                    
                        <!-- ko if: trafficSource() == 1 -->
                            <div class="dropdown select-single">
                                <label class="form-label" for="">Data Source</label>
                                <button class="dropdown-toggle" type="button" data-bind="text: dataSourceSelectedText"></button>

                                <div class="dropdown-list">
                                    <div class="w-form">
                                        <div class="form-group" data-bind="foreach: dataSources">
                                            <input type="radio" data-bind="checked : $parent.dataSourceSelected, value: id,  attr: { 'id': 'dataSource_' + id, 'name' : 'dataSource_' + id }, event:{ change: $parent.onDataSourceChange}">
                                            <label class="form-label" data-bind="attr: {for : 'dataSource_' + id }, text: name"></label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        
                            <div data-bind="visible: dataSourceSelected() === 'sc'">
                                ${this.filterGoogleSources.getHtmlBuild()}
                            </div>
                        <!-- /ko -->
                        
                        <div>
                            ${this.filterDates.getHtmlBuild()}
                        </div>

                        <div data-bind="css: {disabledDiv: !isVisiblePublishDates()}">
                            ${this.filterPublishDates.getHtmlBuild()}
                        </div>
                        
                        <div class="form-check-inline">
                            <input id="checkPublishDates" name="isVisiblePublishDates" data-bind="event: {change: onTogglePublishDates}, checked: isVisiblePublishDates" type="checkbox">
                            <label for="checkPublishDates" class="form-label icon i-check">Enable Publish Date</label>
                        </div>
                        
                    </div>
                </div>   
            </div>

            ${this.validationsList.getHtmlBuild()}
                        
            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                    <div id="selected-brands"></div>
                    <div id="selected-initiatives"></div>
                    <div id="selected-intents"></div>
                    <div id="selected-content-types"></div>
                    <div id="selected-google-sources" data-bind="visible: dataSourceSelected() === 'sc'"></div>
                    <div id="selected-tags"></div>
                    <div id="selected-tag-types"></div>
                    <div id="selected-primary-categories"></div>
                </div>
            </div>

            
            <div class="highlight-page" data-bind="with:statsTotals">
                <div class="highlight-item">
                    <span class="item-title">TAG</span>
                    <strong class="item-value text" data-bind="text: tagName"></strong>
                </div>
                <div class="highlight-item">
                    <span class="item-title">TAG TYPE</span>
                    <strong class="item-value text" data-bind="text: typeName"></strong>
                </div>
                <div class="highlight-item">
                    <span class="item-title"># OF ART..</span>
                    <strong class="item-value " data-bind="text: Number(nbArticles).toLocaleString('en-EG')"></strong>
                </div>
                <!-- ko if: $parent.trafficSource() == 2 || $parent.dataSourceSelected() == "ga" -->
                    <div class="highlight-item">
                        <span class="item-title">SESSIONS</span>
                        <strong class="item-value " data-bind="text: Number(sessions).toLocaleString('en-EG')"></strong>
                    </div>
                    <div class="highlight-item">
                        <span class="item-title">SESS/ART.</span>
                        <strong class="item-value " data-bind="text: Number(sessionsPerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></strong>
                    </div>
                    <div class="highlight-item">
                        <span class="item-title">% OF TOTAL</span>
                        <strong class="item-value " data-bind="text: Number(sessionsOfTotal).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></strong>
                    </div>                                    
                <!-- /ko --> 

                <!-- ko if: $parent.trafficSource() == 1 && $parent.dataSourceSelected() == "sc" -->
                    <div class="highlight-item">
                        <span class="item-title">CLICKS</span>
                        <strong class="item-value " data-bind="text: Number(clicks).toLocaleString('en-EG')"></strong>
                    </div>
                    <div class="highlight-item">
                        <span class="item-title">CLICKS/ART.</span>
                        <strong class="item-value " data-bind="text: Number(clicksPerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></strong>
                    </div>
                    <div class="highlight-item">
                        <span class="item-title">% OF TOTAL</span>
                        <strong class="item-value " data-bind="text: Number(clicksOfTotal).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></strong>
                    </div>
                    <div class="highlight-item">
                        <span class="item-title">IMPRESSIONS</span>
                        <strong class="item-value " data-bind="text: Number(impressions).toLocaleString('en-EG')"></strong>
                    </div>
                    <div class="highlight-item">
                        <span class="item-title">CTR</span>
                        <strong class="item-value " data-bind="text: ctr + '%'"></strong>
                    </div>
                <!-- /ko -->
            </div>
            
            <div class="list-header w-justify">
                
                <div class="w-left">
                    <button data-bind="visible: referrer() != '', event: { click: onClickBack }" class="btn " type="button">Back</button>
                    <h2 class="section-title icon i-tag">Tag Performance Article Report</h2>
                    <div>
                        <label class="toggle">
                            <span class="toggle-label" data-bind="css: (trafficSource() == 1) ? 'is-activated' : ''">GA4</span>
                            <input class="toggle-checkbox" data-bind="event: {change: onToggleTrafficSource}, checked: (trafficSource() == 2)" type="checkbox">
                            <div class="toggle-switch"></div>
                            <span class="toggle-label" data-bind="css: (trafficSource() == 2) ? 'is-activated' : ''">Sentinel</span>
                        </label>
                    </div>
                </div>
                <div class="w-right"> 
                    ${this.pagination.getHtmlBuild()}
                    <button class="btn icon highlight i-export" type="button" data-bind="event: {click: onExportData}">Export</button>
                </div>
            </div>
                
            <div class="w-list-results"  id="list-results">
                    <table class="list-results">
                        
                        <thead>
                            ` + this.headers.getHtmlBuild()  + `
                        </thead>                    
                        
                        <tbody data-bind="foreach: tableData">        
                            <tr data-bind="event: { click: $parent.onClickRowClick.bind($data, $index(), $data) }, css: { 'is-selected': selected, 'is-clicked': $parent.selectedRows().indexOf($index()) !== -1}">
                                
                                <td class="no-wrap">
                                    <div class="w-link">
                                        <span data-bind="visible: ($parent.trafficSource() == 1 && $parent.dataSourceSelected()==='sc' && $parent.filterGoogleSources.selectedItems().includes('search'))">
                                            <button data-bind="event:{click: $parent.onClickGetKeywords}" class="btn icon icon-only i-keywords" type="button"></button>
                                        </span>
                                        <span><a class="link-emaki border" title="view in Emaki" data-bind="attr: {href: 'https://emakicms.com/brand/' + $parent.idBrand() + '/articles/view/' + idArticle}" target="_blank"></a></span>
                                        <span class="no-wrap icon i-ext-link" >
                                            <a class="truncate" data-bind="attr: {href: url}, text: title" target="_blank"></a>
                                        </span>
                                    </div>
                                </td>
                                <td><span data-bind="text: datePublish"></span></td>
                                <td><span data-bind="text: initiativeName"></span></td>
                                <td><span data-bind="text: intentName"></span></td>
                                <td><span data-bind="text: contentTypeName"></span></td>
                                
                                        
                                <!-- ko if: $parent.trafficSource() == 2 || $parent.dataSourceSelected() == "ga" -->
                                    <td><span data-bind="text: Number(sessions).toLocaleString('en-EG')"></span></td>                                    
                                <!-- /ko -->  
                                
                                <!-- ko if: $parent.trafficSource() == 1 && $parent.dataSourceSelected() == "sc" -->
                                    <td><span data-bind="text: Number(clicks).toLocaleString('en-EG')"></span></td>
                                    <td><span data-bind="text: Number(impressions).toLocaleString('en-EG')"></span></td>
                                    <td><span data-bind="text: ctr + '%'"></span></td>
                                <!-- /ko -->
                                
                                <td><div style="width: 120px; height: 70px; border: 1px dotted #eee;" data-bind="attr: { 'id': 'trend-' + idArticle }"></div></td>
                                
                                <!-- ko if: $parent.trafficSource() == 1 && $parent.dataSourceSelected() == "sc" -->
                                    <td style="width: 350px;">
                                        <div class="w-per-bar" data-bind="attr: { title: 'Search: ' + searchDistribution + '% Discover: ' + discoverDistribution + '% News: ' + googleNewsDistribution + '%'}">
                                            <span class="pre-bar search" data-bind="style: { width: searchDistribution + '%' }"></span>
                                            <span class="pre-bar discover" data-bind="style: { width: discoverDistribution + '%' }"></span>
                                            <span class="pre-bar googlenews" data-bind="style: { width: googleNewsDistribution + '%' }"></span>
                                        </div>
                                    </td>
                                <!-- /ko -->    
                            </tr>                 
                        <tbody>
                        <tfoot>
                        </tfoot>
                    </table>
                </div>
                
                <div data-bind="visible: (trafficSource() == 1 && dataSourceSelected()==='sc' && filterGoogleSources.selectedItems().includes('search')), css: {'is-open': isDrawerOpen, loading: isDrawerLoading}" class="drawer search-query">
                    <div class="drawer-notification" data-bind="event: { click: onToggleDrawer }">
                        <strong data-bind="text: keywordPage" class="icon i-keywords">Query</strong>
                        <button data-bind="css: {'open': isDrawerOpen}" class="btn icon i-dropdown-simple " type="button"></button>
                    </div> 
                    <div class="scroll">
                        <table class="list-results" id="list-results">
                            <thead>
                                <tr>                               
                                    <th><span>query</span></th>
                                    <th><span>clicks</span></th>
                                    <th><span>clicks percentage</span></th>
                                    <th><span>impressions</span></th>
                                    <th><span>ctr</span></th>
                                    <th><span>average position</span></th>
                                </tr>
                            </thead>
                            <tbody data-bind="foreach: searchQueryKeywordData">
                                <tr data-bind="event: { click: $parent.onClickRowClick.bind($data, $index(), $data) }, css: { 'is-clicked': $parent.selectedRows().indexOf($index()) !== -1}">
                                    <td class=""><span data-bind="text: keyword"></span></td>
                                    <td class=""><span data-bind="text: Number(clicks).toLocaleString('en-us')"></span></td>
                                    <td class=""><span data-bind="text: percentageClicks"></span></td>
                                    <td class=""><span data-bind="text: Number(impressions).toLocaleString('en-us')"></span></td>
                                    <td class=""><span data-bind="text: ctr"></span></td>
                                    <td class=""><span data-bind="text: averagePosition"></span></td>      
                                </tr>
                            <tbody>
                        </table>
                    </div>
                </div>
            `;
    }

    protected initPartial(): void {

        this.presetFilter = new presetFilter_template("presetFilter", this.getTemplateViewModel(), this.caller);
        this.presetFilter.setType('tagPerformanceArticleReport');

        this.filterInitiatives = new multipleSelector_template("filterInitiatives", this.getTemplateViewModel(), this.caller);
        this.filterInitiatives.setTagContainerId('selected-initiatives');
        this.filterInitiatives.setTagContainerCaption('Selected mappings:');
        this.filterInitiatives.setLabel("Mappings");

        this.filterIntents = new multipleSelector_template("filterIntents", this.getTemplateViewModel(), this.caller);
        this.filterIntents.setTagContainerId('selected-intents');
        this.filterIntents.setTagContainerCaption('Selected Intents:');
        this.filterIntents.setLabel("Intents");

        this.filterContentTypes = new multipleSelector_template("filterContentTypes", this.getTemplateViewModel(), this.caller);
        this.filterContentTypes.setTagContainerId('selected-content-types');
        this.filterContentTypes.setTagContainerCaption('Selected Content Types:');
        this.filterContentTypes.setLabel("Content Types");

        this.primaryCategoriesFilter = new filterMultipleAutoComplete_template("primaryCategoriesFilter", this.getTemplateViewModel(), this.caller);
        this.primaryCategoriesFilter.setIsVisible(1);
        this.primaryCategoriesFilter.setPlaceHolderText("Primary Category");
        this.primaryCategoriesFilter.setIcon("i-tag-a");
        this.primaryCategoriesFilter.setTagContainerId('selected-primary-categories');
        this.primaryCategoriesFilter.setTagContainerCaption('Selected Primary Categories:');
        this.primaryCategoriesFilter.setMinInputSuggestionLength(2);

        this.filterGoogleSources = new multipleSelector_template("filterGoogleSources", this.getTemplateViewModel(), this.caller);
        this.filterGoogleSources.setTagContainerId('selected-google-sources');
        this.filterGoogleSources.setTagContainerCaption('Selected Google Sources:');
        this.filterGoogleSources.setLabel("Google Sources");

        let startDate = new Date();
        startDate.setHours(0,0,0,0);
        startDate.setDate(startDate.getDate() - 30);
        let endDate = new Date();
        endDate.setHours(0,0,0,0);
        endDate.setDate(endDate.getDate() - 1);

        this.filterDates = new filterDate_template("filterDates", this.getTemplateViewModel(), this.caller);
        this.filterDates.setDateRange(startDate, endDate);


        this.filterPublishDates = new filterDate_template("filterPublishDates", this.getTemplateViewModel(), this.caller);
        this.filterPublishDates.setStartPickerId('publishStartDate');
        this.filterPublishDates.setEndPickerId('publishEndDate');
        this.filterPublishDates.setDateRange(startDate, endDate);

        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;

        this.exportDataCsv = new exportDataCsv();

        this.headers = new simpleListHeader_template("listHeader", this.getTemplateViewModel(), this.caller, []);

        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this);
    }

    protected getTemplateName(): string {

        return "tagPerformanceArticleReport_template";
    }

    protected getMainElementClasses(): Array<string> {

        return [];
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let huit_neuf_this = this;

        return {
            referrer: ko.observable(""),
            idBrand: ko.observable(""),
            brand: ko.observable(""),
            idTag: ko.observable(""),
            tableData: ko.observableArray([]),
            statsTotals: ko.observable({tagName: "", typeName: "", clicks:"0", clicksOfTotal: "0", clicksPerArticle: "0", ctr: "0", impressions: "0", nbArticles: "0", sessions: "0", sessionsOfTotal: "0", sessionsPerArticle: "0"}),
            exportData: ko.observableArray([]),

            viewModes: ko.observableArray([]),
            viewModeSelected: ko.observable("article"),
            viewModeSelectedText: ko.observable("Article"),

            dataSources: ko.observableArray([]),
            dataSourceSelected: ko.observable("ga"),
            dataSourceSelectedText: ko.observable("Google Analytics"),

            isVisiblePublishDates: ko.observable(false),

            keywordPage: ko.observable("Keywords"),

            searchQueryKeywordData: ko.observableArray([]),
            isDrawerOpen: ko.observable(0),
            isDrawerLoading: ko.observable(0),
            selectedRows: ko.observableArray([]),
            trafficSource : ko.observable(2),


            onClickBack: function(){

                huit_neuf_this.onClickBack();
            },
            onTogglePublishDates: function(data, event){

                huit_neuf_this.onTogglePublishDates(data, event);
            },
            onViewModeChange: function (data) {

                huit_neuf_this.onViewModeChange(data);
            },
            onDataSourceChange: function (data) {

                huit_neuf_this.onDataSourceChange(data);
            },
            onToggleDrawer: function() {

                huit_neuf_this.onToggleDrawer();
            },
            onClickGetKeywords : function(data){

                huit_neuf_this.onClickGetKeywords(data);
            },
            onExportData: function() {
                huit_neuf_this.onExportData();
            },
            onClickRowClick: function(index, data){
                huit_neuf_this.onClickRowClick(index);
                return true;
            },
            onToggleTrafficSource : function(data, event){
                huit_neuf_this.onToggleTrafficSource(data, event);
            },
        };
    }

    public onToggleTrafficSource(data, event){

        let toggleValue = this.getTemplateViewModel().trafficSource();

        if (toggleValue == 2) {

            this.getTemplateViewModel().trafficSource(1);
        }else {

            this.getTemplateViewModel().trafficSource(2);
            this.getTemplateViewModel().filterGoogleSources.selectedItems([]);
            this.getTemplateViewModel().filterGoogleSources.setTags([], []);
            this.getTemplateViewModel().dataSourceSelected("ga");
            this.getTemplateViewModel().dataSourceSelectedText("Google Analytics");
            this.setTableHeaderItems();
        }

        this.caller.getReportData();
    }

    public getViewModelForRequest() {

        return {
            filter: {
                viewMode: this.getTemplateViewModel().viewModeSelected(),
                idInitiatives: this.getTemplateViewModel().filterInitiatives.selectedItems(),
                idIntents: this.getTemplateViewModel().filterIntents.selectedItems(),
                idContentTypes: this.getTemplateViewModel().filterContentTypes.selectedItems(),
                idPrimaryCategories: this.getTemplateViewModel().primaryCategoriesFilter.selectedItemIds(),
                namePrimaryCategories: this.getTemplateViewModel().primaryCategoriesFilter.selectedItemNames(),
                dataSource: this.getTemplateViewModel().dataSourceSelected(),
                googleSources: this.getTemplateViewModel().filterGoogleSources.selectedItems(),
                dateFilterType: this.getTemplateViewModel().filterDates.selectedFilter(),
                startDate: this.getTemplateViewModel().filterDates.startDate(),
                endDate: this.getTemplateViewModel().filterDates.endDate(),
                startDateRange: this.getTemplateViewModel().filterDates.fromRange(),
                endDateRange: this.getTemplateViewModel().filterDates.toRange(),
                isPublishDatesEnabled: this.getTemplateViewModel().isVisiblePublishDates(),
                publishDateFilterType: this.getTemplateViewModel().filterPublishDates.selectedFilter(),
                publishDateStart: this.getTemplateViewModel().filterPublishDates.startDate(),
                publishDateEnd: this.getTemplateViewModel().filterPublishDates.endDate(),
                publishStartDateRange: this.getTemplateViewModel().filterPublishDates.fromRange(),
                publishEndDateRange: this.getTemplateViewModel().filterPublishDates.toRange(),
                idBrand: this.getTemplateViewModel().idBrand(),
                idTag: this.getTemplateViewModel().idTag(),
                referrer: this.getTemplateViewModel().referrer(),
                trafficSource: this.getTemplateViewModel().trafficSource(),

            },
            pagination: this.getTemplateViewModel().pagination,
            headers: this.headers.getViewModelForRequest(),
        }
    }

    public build(classesToAdd: Array<string> = []): HTMLElement {

        let container = super.build(classesToAdd);
        return container;
    }

    public buildDatePickerCalendar() {

        this.filterDates.buildCalendar();
        this.filterPublishDates.buildCalendar();
    }

    public setViewModesItems() {

        this.getTemplateViewModel().viewModes(this.viewModes);
    }

    public setDataSourcesItems() {

        this.getTemplateViewModel().dataSources(this.dataSources);
    }

    public setInitiativesItems(items) {

        for (let item of items){

            item['name'] = item['initiative'];
        }
        items.unshift({'id': 0, 'name' : 'no mappings'});

        this.filterInitiatives.setItems(items);
    }

    public setIntentsItems(items) {

        this.filterIntents.setItems(items);
    }

    public setContentTypesItems(items) {

        let groups = [];
        for (let groupedContentType of items){

            let group = {"name" : groupedContentType.name, "items" : groupedContentType.contentTypes};
            groups.push(group);
        }

        this.filterContentTypes.setMultiSectionItems(groups);
    }

    public setPrimaryCategoriesFilterItems(items){

        this.primaryCategoriesFilter.setItems(items);
    }

    public setGoogleSourcesItems() {

        this.filterGoogleSources.setItems(this.googleSources);
    }

    public setTableHeaderItems() {

        if (this.getTemplateViewModel().dataSourceSelected() == "ga") {

            this.headers.setHeadersLevels(this.gaDataSourceHeaders);
            this.headers.getTemplateViewModel().orderBy("sessions");
            this.headers.getTemplateViewModel().orderByDirection("DESC");
            this.headers.getTemplateViewModel().orderByAndDirection("sessions_DESC");
        }else {

            this.headers.setHeadersLevels(this.scDataSourceHeaders);
            this.headers.getTemplateViewModel().orderBy("clicks");
            this.headers.getTemplateViewModel().orderByDirection("DESC");
            this.headers.getTemplateViewModel().orderByAndDirection("clicks_DESC");
        }
    }

    public onTogglePublishDates(data, event){

        this.getTemplateViewModel().isVisiblePublishDates((event.target.checked) ? 1 : 0);
        this.caller.getReportData();
    }

    public onToggleDrawer(){

        this.getTemplateViewModel().isDrawerOpen(!this.getTemplateViewModel().isDrawerOpen());
    }

    private onViewModeChange(selected) {

        this.getTemplateViewModel().viewModeSelectedText(selected.name);
        this.caller.getReportData();
    }

    private onDataSourceChange(selected){

        this.getTemplateViewModel().dataSourceSelectedText(selected.name);
        this.setTableHeaderItems()
        this.caller.getReportData();
    }

    private onClickBack(){

        page(this.getTemplateViewModel().referrer());
    }

    public onClickGetKeywords(data){

        let brand = this.getTemplateViewModel().brand();

        let values = this.getTemplateViewModel().tableData();
        for (let value of values) {

            value['selected'] = 0;
        }

        data['selected'] = 1;

        this.getTemplateViewModel().tableData([]);
        this.getTemplateViewModel().tableData(values);
        this.addTrendGraphs(values);

        this.getTemplateViewModel().isDrawerOpen(1);
        this.getTemplateViewModel().isDrawerLoading(1);
        this.getTemplateViewModel().keywordPage(data.url);
        this.caller.getSearchQueryKeywordData(data);
    }

    public setIdBrand(idBrand){

        this.getTemplateViewModel().idBrand(idBrand);
    }

    public setBrand(brand){

        this.getTemplateViewModel().brand(brand);
    }

    public setTag(idTag){

        this.getTemplateViewModel().idTag(idTag);
    }

    public setReferrer(referrer){

        this.getTemplateViewModel().referrer(referrer);
    }

    public setStatsTotals(statsTotals){

        this.getTemplateViewModel().statsTotals(statsTotals);
    }

    public setSearchQueryKeywordData(searchQueryKeywordData) {

        this.getTemplateViewModel().searchQueryKeywordData(searchQueryKeywordData);
        this.getTemplateViewModel().isDrawerLoading(0);
    }

    public setTableData(tableData){

        for (let data of tableData) {

            data['selected'] = 0;
            data['url'] = "https://" + this.getTemplateViewModel().brand().domain + data.permalink;
        }

        this.getTemplateViewModel().tableData(tableData);
        this.addTrendGraphs(tableData);
    }

    public addTrendGraphs(tableData) {


        for (let graphData of tableData) {

            am4core.useTheme(am4themes_animated);

            var chart = am4core.create("trend-" + graphData.idArticle , am4charts.XYChart);

            if (chart.logo) {

                chart.logo.disabled = true;
            }

            chart.data = graphData.trendData;

            chart.padding(0, 0, 0, 0);

            var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
            dateAxis.renderer.grid.template.disabled = true;
            dateAxis.renderer.labels.template.disabled = true;
            dateAxis.startLocation = 0.5;
            dateAxis.endLocation = 0.7;
            dateAxis.cursorTooltipEnabled = false;

            var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            valueAxis.min = 0;
            valueAxis.renderer.grid.template.disabled = true;
            valueAxis.renderer.baseGrid.disabled = true;
            valueAxis.renderer.labels.template.disabled = true;
            valueAxis.cursorTooltipEnabled = false;

            chart.cursor = new am4charts.XYCursor();
            chart.cursor.lineY.disabled = true;

            var series = chart.series.push(new am4charts.LineSeries());
            series.tooltipText = "{date}: [bold]{value} " + ((this.getTemplateViewModel().dataSourceSelected() == "ga") ? "sessions" : "clicks");
            series.dataFields.dateX = "date";
            series.dataFields.valueY = "value";
            series.tensionX = 0.8;
            series.strokeWidth = 2;

            // render data points as bullets
            var bullet = series.bullets.push(new am4charts.CircleBullet());
            bullet.circle.opacity = 0;
            bullet.circle.propertyFields.opacity = "opacity";
            bullet.circle.radius = 3;
        }
    }

    public resetPageNumber(): void {

        this.pagination.getTemplateViewModel().pageNumber(1);
    }

    public setPaginationTotalCount(totalCount: number):  void {

        this.pagination.setNumberItemToPaginate(totalCount);
    }

    public setViewModelFromRequest(params : Array<any>): void{


        this.presetFilter.setMultiSelectorPresetFilters(this.filterInitiatives, params['filter']['idInitiatives']);
        this.presetFilter.setMultiSelectorPresetFilters(this.filterIntents, params['filter']['idIntents']);
        this.presetFilter.setMultiSelectorPresetFilters(this.filterContentTypes, params['filter']['idContentTypes']);
        this.presetFilter.setMultiSelectorPresetFilters(this.filterGoogleSources, params['filter']['googleSources']);

        this.presetFilter.setMultipleAutocompletePresetFilter(this.primaryCategoriesFilter, params['filter']['idPrimaryCategories'], params['filter']['namePrimaryCategories']);

        this.presetFilter.setDates(this.filterDates, params['filter']['dateFilterType'], params['filter']['startDate'], params['filter']['endDate'], params['filter']['startDateRange'], params['filter']['endDateRange']);

        this.presetFilter.setDates(this.filterPublishDates, params['filter']['publishDateFilterType'], params['filter']['publishDateStart'], params['filter']['publishDateEnd'], params['filter']['publishStartDateRange'], params['filter']['publishEndDateRange']);

        if (params['filter']['dataSource'] == "ga") {

            this.getTemplateViewModel().dataSourceSelected("ga");
            this.getTemplateViewModel().dataSourceSelectedText("Google Analytics");
        }else {

            this.getTemplateViewModel().dataSourceSelected("sc");
            this.getTemplateViewModel().dataSourceSelectedText("Search Console");
        }

        this.setTableHeaderItems();

        if(typeof params['filter']['referrer'] !== 'undefined'){

            this.getTemplateViewModel().referrer(params['filter']['referrer']);
        }

        if(typeof params['filter']['isPublishDatesEnabled'] !== 'undefined'){

            this.getTemplateViewModel().isVisiblePublishDates(params['filter']['isPublishDatesEnabled']);
        }
        
        if (typeof params['filter']['trafficSource'] !== 'undefined') {
            this.getTemplateViewModel().trafficSource(params['filter']['trafficSource']);
        }
    }

    private onExportData(){

        this.caller.getExportData();
    }

    public setExportData(exportData){

        let exportDataView = [];
        for (let exportDataRow of exportData) {

            let exportDataViewRow = [];
            exportDataViewRow["idArticle"] = exportDataRow.idArticle;
            exportDataViewRow["Article"] = exportDataRow.title;
            exportDataViewRow["Latest PubDate"] = exportDataRow.datePublish;
            exportDataViewRow["Initiative"] = exportDataRow.initiativeName;
            exportDataViewRow["Intent"] = exportDataRow.intentName;
            exportDataViewRow["Content Type"] = exportDataRow.contentTypeName;

            if (this.getTemplateViewModel().trafficSource() == 2 || this.getTemplateViewModel().dataSourceSelected() == "ga") {

                exportDataViewRow["Sessions"] = Number(exportDataRow.sessions).toLocaleString('en-EG');
            }
            else if (this.getTemplateViewModel().dataSourceSelected() == "sc") {

                exportDataViewRow["Clicks"] = Number(exportDataRow.clicks).toLocaleString('en-EG');
                exportDataViewRow["Impressions"] = Number(exportDataRow.impressions).toLocaleString('en-EG');
                exportDataViewRow["CTR"] = exportDataRow.ctr + '%';
                exportDataViewRow["Distribution"] = 'Search: ' + exportDataRow.searchDistribution + '% Discover: ' + exportDataRow.discoverDistribution + '% News: ' + exportDataRow.googleNewsDistribution + '%';
            }

            exportDataView.push(exportDataViewRow);
        }

        this.getTemplateViewModel().exportData(exportDataView);
    }

    public clearAndCloseSearchDrawer() {

        this.getTemplateViewModel().keywordPage("Keywords");
        this.getTemplateViewModel().searchQueryKeywordData([]);
        this.getTemplateViewModel().isDrawerOpen(0);
    }

    private exportData(obj){

        this.exportDataCsv.exportToCsv("TagPerformanceArticleExport", this.getTemplateViewModel().exportData());
    }

    private onClickRowClick(index){

        let selectedRows = this.getTemplateViewModel().selectedRows();
        let check = selectedRows.indexOf(index);

        if (check !== -1) {

            selectedRows.splice(check, 1);
        }else {

            selectedRows.push(index);
        }

        this.getTemplateViewModel().selectedRows(selectedRows);
    }

    public resetSelectedRows(){

        this.getTemplateViewModel().selectedRows([]);
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/tagPerformanceArticleReport_template.ts